/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M1 8.5C1 4.364 4.364 1 8.5 1S16 4.364 16 8.5 12.636 16 8.5 16 1 12.636 1 8.5m22.439 12.232l-7.738-7.738A8.434 8.434 0 0017 8.5C17 3.813 13.187 0 8.5 0 3.813 0 0 3.813 0 8.5 0 13.187 3.813 17 8.5 17a8.434 8.434 0 004.494-1.299l7.738 7.738a1.916 1.916 0 002.707-2.707" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
